export default __webpack_public_path__ + "16956ea3cc38be33dc3326f2bb5d3867.png";